const enumSessBlock = 'block';
const enumSessIsActive = 'is_active';
const enumSessAccessToken = 'access_token';
const enumSessRefreshToken = 'refresh_token';
const enumSessTimeStarted = 'session_started';
const enumSessExpiresIn = 'expires_in';

export {
  enumSessBlock,
  enumSessIsActive,
  enumSessTimeStarted,
  enumSessRefreshToken,
  enumSessAccessToken,
  enumSessExpiresIn
}
